// src/config/apiConfig.js

// const API_BASE_URL = 'http://192.168.1.18:3005/todoalbarril';  // Aquí defines tu URL base
const API_BASE_URL = 'https://appmagdalena.net/todoalbarril';  // Aquí defines tu URL base

export default API_BASE_URL;
